import { useMemo } from 'react';
import { routes } from '~/constants';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { Accounting } from '~/types/api.model';
export function useIntegration() {
    let accounting = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Accounting.QBO;
    const { api } = useStoreActions();
    const { showErrorToast } = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    return useMemo(()=>({
            async connect (redirectUrl) {
                const actualRedirectUrl = redirectUrl != null ? redirectUrl : "http://".concat(window.location.host).concat(routes.availableApps);
                const response = await handleRequest(api.accounting.connect({
                    redirectUrl: actualRedirectUrl,
                    accounting
                }));
                if (!response.success) {
                    showErrorToast(commonTexts.toasts.failedToConnect(), 'failed-to-connect-toast');
                } else {
                    return response.data;
                }
            },
            async disconnect () {
                const integration = await handleRequest(api.accounting.disconnect({
                    accounting
                }));
                if (!integration.success) {
                    showErrorToast(commonTexts.toasts.failedToDisconnect(), 'failed-to-disconnect-toast');
                } else {
                    return integration.data;
                }
            },
            async updateSettings (settings) {
                const result = await handleRequest(api.accounting.updateSettings({
                    accounting,
                    settings
                }));
                if (!result.success) {
                    showErrorToast(commonTexts.toasts.failedToUpdateIntegrationSettings(), 'failed-to-sync-toast');
                    return result;
                }
                return result;
            }
        }), []);
}
